<template>
  <div id="app-center">
    <my-head></my-head>
    <center-head></center-head>
    <div class="center-box">
      <div class="center-list">
        <el-row :gutter="30">
          <el-col :span="4">
            <left-menu></left-menu>
          </el-col>

          <el-col :span="20">
            <div class="center-left">
              <WtDataTable ref="tables" :listUrl="$db.config.com_project.donate.list">
                <div slot="buttons">
                  <el-button
                    size="small"
                    style="margin:10px 0px"
                    icon="el-icon-plus"
                    type="primary"
                    @click="doDonate"
                  >我要捐赠</el-button>
                </div>
                <template slot="columns">
                  <el-table-column label="捐赠日期" prop="donation_time" align="center" min-width="150">
                    <template slot-scope="scope">
                      <span>{{scope.row.donation_time}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="捐款金额" align="center" width="200" prop="money">
                    <template slot-scope="scope">
                      <span>{{scope.row.money | setNumFormat}}</span>
                    </template>
                  </el-table-column>

                  <el-table-column
                    align="center"
                    label="收款状态"
                    prop="if_receive_text"
                    min-width="100"
                  ></el-table-column>

                  <el-table-column align="center" label="操作" min-width="150">
                    <template slot-scope="scope">
                      <el-button-group>
                        <el-button
                          type="primary"
                          size="mini"
                          icon="el-icon-view"
                          v-if="scope.row.if_receive == 1"
                          @click="showDetail(scope.row.id)"
                        >捐款信息</el-button>
                        <el-button
                          type="primary"
                          size="mini"
                          icon="el-icon-circle-check"
                          v-else
                          @click="doEdit(scope.row.id)"
                        >修改捐款</el-button>
                        <el-button
                          type="danger"
                          :disabled="!(scope.row.if_receive == 3)"
                          icon="el-icon-delete"
                          @click="publicDel(scope.row.id)"
                          size="mini"
                        >删除</el-button>
                      </el-button-group>
                    </template>
                  </el-table-column>
                </template>
              </WtDataTable>

              <el-dialog
                :visible.sync="donate_modal"
                title="捐款信息"
                center
                width="40%"
                :close-on-click-modal="false"
              >
                <el-dialog :visible.sync="img_show" append-to-body>
                  <img width="100%" :src="img_url" alt />
                </el-dialog>

                <el-form
                  :model="donateForm"
                  ref="donateFormRef"
                  label-width="100px"
                  :rules="rules"
                  style="width:96%;"
                  :disabled="if_look"
                >
                  <el-form-item label="捐款时间" prop="donation_time">
                    <el-date-picker
                      style="width:85%"
                      v-model="donateForm.donation_time"
                      type="date"
                      format="yyyy-MM-dd"
                      value-format="yyyy-MM-dd"
                      placeholder="选择捐款日期"
                    ></el-date-picker>
                  </el-form-item>

                  <el-form-item label="金额" prop="money">
                    <!-- <el-input-number v-model="donateForm.money" style="width:45%;text-align:left" :controls="false" :precision="2" :max="payInfo.max" :min="payInfo.min"></el-input-number> -->
                    <el-input
                      v-model.number="donateForm.money"
                      maxlength="9"
                      placeholder="请输入金额"
                      style="width:85%"
                    ></el-input>
                    <p v-if="DX(donateForm.money)">人民币：{{DX(donateForm.money)}}</p>
                  </el-form-item>

                  <el-form-item label="捐款凭证">
                    <el-upload
                      ref="imgUploads"
                      :action="uploadImgUrl"
                      list-type="picture-card"
                      :on-preview="showImg"
                      :data="uploadParms"
                      :file-list="defImg1"
                      name="img"
                      :before-upload="beforeUpload"
                      :on-success="(response, file, fileList) =>{
                      handlerUpload(fileList,'defImg1');
                    }"
                      :on-remove="(file, fileList) =>{
                      handlerUpload(fileList,'defImg1');
                    }"
                    >
                      <i class="el-icon-plus"></i>
                    </el-upload>
                  </el-form-item>

                  <el-form-item label="备注信息" prop="remark">
                    <el-input
                      type="textarea"
                      :autosize="{ minRows: 2, maxRows: 4}"
                      placeholder="请输入捐款备注内容"
                      v-model="donateForm.remark"
                    ></el-input>
                  </el-form-item>
                </el-form>

                <span slot="footer">
                  <el-button type="danger" size="small" icon="el-icon-close" @click="cancelBtn">关闭</el-button>
                  <el-button
                    type="primary"
                    size="small"
                    v-if="!if_look"
                    icon="el-icon-check"
                    @click="submitBtn"
                    :loading="loading"
                  >提交</el-button>
                </span>
              </el-dialog>
            </div>
          </el-col>
        </el-row>
        <!-- Form -->
      </div>

      <foot-div></foot-div>
    </div>
  </div>
</template>
<script>
import baseUrl from "@/config/index";
import myHead from "../../public/head";
import centerHead from "../../public/center_head";
import leftMenu from "../../public/menu";
import footDiv from "../../public/foot";
export default {
  components: {
    myHead,
    centerHead,
    leftMenu,
    footDiv
  },
  data() {
    var checkMoney = (rule, value, callback) => {
      if (Number(this.donateForm.money) > 0) {
        return callback();
      } else {
        return callback(new Error("请输入捐款金额！"));
      }
    };

    return {
      loading: false,
      if_look: false, //是否是查看详情

      defImg1: [],

      donate_modal: false, //上传捐款凭证modal

      donateForm: {
        id: null,
        money: null,
        donation_time: null,
        pic: [],
        pic_path: []
      }, //上传捐款凭证数据

      rules: {
        money: [
          { required: true, message: "请输入捐款金额！", trigger: "blur" },
          { validator: checkMoney }
        ],
        donation_time: [
          { required: true, message: "请输入捐款时间！", trigger: "change" }
        ]
      },

      uploadImgUrl: "", //上传图片接口url
      img_url: "", //图片预览路径
      img_show: false, //图片预览弹窗
      uploadParms: { file_type: 2 } //图片上传所需参数
    };
  },
  methods: {
    //我要捐赠操作
    doDonate() {
      this.donateForm.id = null;
      this.if_look = false;
      this.donateForm.donation_time = this.getCurrentTime();
      this.donate_modal = true;
    },

    handlerUpload(fileList, name) {
      this.$set(this, name, []);
      this.$set(this, name, fileList);
    },

    //金额转成大写
    DX(n) {
      if (Number(n) > 0) {
        if (!/^(0|[1-9]\d*)(\.\d+)?$/.test(n)) return "";
        var unit = "仟佰拾亿仟佰拾万仟佰拾元角分",
          str = "";
        n += "00";
        var p = n.indexOf(".");
        if (p >= 0) n = n.substring(0, p) + n.substr(p + 1, 2);
        unit = unit.substr(unit.length - n.length);
        for (var i = 0; i < n.length; i++)
          str += "零壹贰叁肆伍陆柒捌玖".charAt(n.charAt(i)) + unit.charAt(i);
        return str
          .replace(/零(仟|佰|拾|角)/g, "零")
          .replace(/(零)+/g, "零")
          .replace(/零(万|亿|元)/g, "$1")
          .replace(/(亿)万|壹(拾)/g, "$1$2")
          .replace(/^元零?|零分/g, "")
          .replace(/元$/g, "元整");
      } else {
        return false;
      }
    },

    // 取消捐款弹框
    cancelBtn() {
      this.$refs["donateFormRef"].resetFields();
      this.$refs["imgUploads"].clearFiles(); //清空图片
      this.donate_modal = false;
    },

    beforeUpload(file) {
      let bool = this.$fnc.checkUploadImg(file);
      return bool;
    },

    //预览图片
    showImg(file) {
      this.img_url = file.url;
      this.img_show = true;
    },

    //编辑操作
    doEdit(id) {
      this.if_look = false;
      this.getDetail(id);
    },

    //查看详情
    showDetail(id) {
      this.if_look = true;
      this.getDetail(id);
    },

    //获取编辑数据
    getDetail(id) {
      this.$db
        .post(this.$db.config.com_project.donate.info, { id: id })
        .then(res => {
          if (res.code == 200) {
            this.donateForm = res.data;
            this.defImg1 = res.data.pic_path;
            this.donate_modal = true;
          }
        });
    },

    //删除操作
    //删除
    publicDel(id) {
      this.$confirm("确定删除这条捐赠信息吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.$db
            .post(this.$db.config.com_project.donate.delete, { id: id })
            .then(res => {
              if (res.code == 200) {
                this.$message.success("删除成功！");
                this.$refs.tables.reloadData();
              }
            });
        })
        .catch(() => {});
    },

    //提交捐款凭证操作
    submitBtn() {
      let url;

      if (this.defImg1 && this.defImg1.length > 0) {
        let arr = [];

        this.defImg1.forEach((item, index) => {
          if (item.hasOwnProperty("response")) {
            arr.push(item.response.data.id);
          } else {
            arr.push(item.id);
          }
        });
        this.donateForm.pic = arr;
      } else {
        // return this.$message.warning("请上传捐款凭证！");
      }

      this.$refs["donateFormRef"].validate(valid => {
        if (valid) {
          this.loading = true;
          if (this.donateForm.id > 0) {
            url = this.$db.config.com_project.donate.update;
          } else {
            url = this.$db.config.com_project.donate.insert;
          }

          this.$db.post(url, this.donateForm).then(res => {
            this.loading = false;
            if (res && res.code == 200) {
              this.$message.success(res.msg);
              this.cancelBtn();
              this.$refs.tables.reloadData();
            }
          });
        } else {
          this.$message.warning("请填写完整信息！");
        }
      });
    },

    /**
     * 获取当前时间
     * @param  {Number} type [1:Y-m-d 2:Y-m-d H 3:Y-m-d H:i 4:Y-m-d H:i:s]
     * @return {[type]}      [description]
     */
    getCurrentTime(type = 1) {
      var date = new Date();
      var seperator1 = "-";
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var strDate = date.getDate();
      var hour = date.getHours();
      var minute = date.getMinutes();
      var second = date.getSeconds();
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
      }
      if (hour >= 1 && hour <= 9) {
        hour = "0" + hour;
      }
      if (minute >= 1 && minute <= 9) {
        minute = "0" + minute;
      }
      if (second >= 1 && second <= 9) {
        second = "0" + second;
      }
      let current = year + seperator1 + month + seperator1 + strDate;
      switch (type) {
        case 1:
          break;
        case 2:
          current = current + " " + hour;
          break;
        case 3:
          current = current + " " + hour + ":" + minute;
          break;
        case 4:
          current = current + " " + hour + ":" + minute + ":" + second;
          break;
      }
      return current;
    }
  },
  mounted() {
    this.uploadImgUrl = baseUrl + this.$db.config.uploadImgUrl;
  }
};
</script>
<style lang="scss" scoped>
#app-center {
  width: 100%;
  background-color: #f1f1f1;
}
.center-box {
  .center-list {
    margin: 0 auto;
    width: 98%;
    padding-top: 20px;
    .center-left {
      background-color: #fff;
      border-top: 2px solid #b60205;
      padding-top: 30px;
      overflow: hidden;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Hospital/comproject/donate/list.vue